import store from '@/store'
import config from '@/utils/config'
import request from '@/utils/request'

const getColorJson = (element: string) => {
  let url = ''
  if (element.startsWith('tem')) {
    url = '/cw/choroplethic/color_json/tem'
  } else if (element.startsWith('pre')) {
    url = '/cw/choroplethic/color_json/pre'
  }
  return request.get(url, null).then((data: any) => {
    if (data.length > 0) {
      return data
    }
  })
}
const getGeoJson = (data: any[], element: string) => {
  const knowValues = []
  // console.log(data)
  const arr = data.filter((e) => {
    return e.value !== '--'
  })
  for (const item of arr) {
      const value = item.value
      // const value = item[element]
      // if (value === '--') {
      //     continue
      // } else {
      //   knowValues.push([parseFloat(item.lon), parseFloat(item.lat), parseFloat(value)])
      // }
      knowValues.push([parseFloat(item.lon), parseFloat(item.lat), parseFloat(value)])
  }
  if (knowValues.length < 3) {
      return {}
  }
  let ele = ''
  if (element.indexOf('pre') > -1) {
    ele = 'pre'
  }
  if (element.indexOf('tem') > -1) {
    ele = 'tem'
  }
  const { current } = store.state
  // let params = {}
  // if (current) {
  //   params = {areaCode: current.areaId, type: ele, size: 90, knowValues}
  // } else {
  //   params = {areaCode: config.defaultStationObj.adminCode, type: ele, size: 90, knowValues}
  // }
  const params = {areaCode: config.defaultStationObj.adminCode, type: ele, size: 90, knowValues}
  return request.post('/cw/choroplethic/geo_json', params).then((result: any) => {
    return result
  })
}
export default { getColorJson, getGeoJson }
